export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const STATUS_CHANGE = 'STATUS_CHANGE';
export const PAGESKIP = 'PAGESKIP';
export const SETTOPINFO = 'SETTOPINFO';
export const CLOSETOPINFO = 'CLOSETOPINFO';
export const OPENWILLSHOW = 'OPENWILLSHOW';
export const CLOSEWILLSHOW = 'CLOSEWILLSHOW';

export const SETCLOUDHOST = 'SETCLOUDHOST';

// lang
export const SELECT_LANG = 'SELECT_LANG';

// login expired
export const LOGIN_EXPIRED = 'LOGIN_EXPIRED';

// logout forced
export const LOGOUT_FORCED = 'LOGOUT_FORCED';

// login error
export const LOGIN_ERROR = 'LOGIN_ERROR';

export const SHOW_BETA = 'SHOW_BETA';

// webview
export const RETURN_TO_WEBVIEW_FIRST_TIME = 'RETURN_TO_WEBVIEW_FIRST_TIME';

// reolink lab
export const LAB = 'LAB';
export const LAB_DEVICE = 'LAB_DEVICE';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js